import React, { useState, useEffect } from "react";
import axios from "axios";
import "./LoginPage.css";

// Logout function
function logoutUser() {
  localStorage.removeItem("authToken");
  localStorage.removeItem("userRole");
  localStorage.removeItem("currentUserId");
  window.location.href = "/login";
}

// Set logout timer based on JWT expiry
function setLogoutTimer(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const exp = payload.exp * 1000; // convert to ms
    const timeout = exp - Date.now();
    if (timeout > 0) {
      // Clear any previous timer
      if (window.__logoutTimer) clearTimeout(window.__logoutTimer);
      window.__logoutTimer = setTimeout(() => {
        logoutUser();
      }, timeout);
    } else {
      logoutUser();
    }
  } catch (e) {
    logoutUser();
  }
}

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const getApiUrl = () => {
    return "/api"; // Standardized API base path
  };

  const API_URL = getApiUrl(); // Get the correct API URL based on the domain

  useEffect(() => {
    // On app load, set timer if token exists
    const token = localStorage.getItem("authToken");
    if (token) {
      setLogoutTimer(token);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Send only the username and password to the backend for authentication
      const response = await axios.post(`${API_URL}/authenticate`, {
        username: username,
        password: password,
      });

      // Handle the response on success
      if (response.status === 200) {
        const { token, user } = response.data;
        const role = user.role; // match exact casing from backend
        const id = user.id;

        localStorage.setItem("authToken", token);
        localStorage.setItem("userRole", role);
        localStorage.setItem("currentUserId", id);
        setLogoutTimer(token); // <-- Add this line
        // Redirect based on role
        if (role === "Admin") {
          window.location.href = "/user/dashboard";
        } else {
          window.location.href = "/user/imoveis"; // Redirect non-admin users to List Imoveis
        }
      }
    } catch (error) {
      if (error.response) {
        // Handle specific backend error messages
        if (error.response.status === 403) {
          setErrorMessage("Your account is inactive. Please contact support.");
        } else if (error.response.status === 401) {
          setErrorMessage("Invalid username or password.");
        } else {
          setErrorMessage("An error occurred during login. Please try again.");
        }
      } else {
        console.error("Error during login", error);
        setErrorMessage("An error occurred during login. Please try again.");
      }
    }
  };

  return (
    <div className="login-container">
      <h2>Login to Kubitu's Imoveis Backoffice</h2>
      <form onSubmit={handleSubmit} className="login-form">
        <div className="form-group">
          <label htmlFor="username">Username:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        <button type="submit" className="login-button">
          Login
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
